import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import useApproveLoan from '../../resources/applications/approveLoan';

const useForm = () => {
  const onSubmit = (form) => ({
    loan_id: form.loanPackageId,
  });

  return useSWRMutationForm({
    useMutation: () => useApproveLoan(),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
    formOptions: {
      defaultValues: {
        loanPackageId: '',
      },
    },
  });
};

export default useForm;
